import { Box } from '../BoxNew'
import { Image } from '../ImageNew'
import { Text } from '../TextNew'
import styles from './styles'
import { CarousalItemProp, CarousalTypes } from './types'

const CarousalItem = (props: CarousalItemProp) => {
  const { type, data, selected, onPress } = props
  if (type === CarousalTypes.HOTEL_DETAIL) {
    return (
      <Box>
        <Text>HOTEL_DETAIL</Text>
      </Box>
    )
  }
  if (type === CarousalTypes.ROOM_TYPE) {
    return (
      <Box>
        <Text>CarousalRoomTypesItem</Text>
      </Box>
    )
  }
  return (
    <Box
      {...styles[type].itemContainer(selected)}
      onPress={onPress}
      underlayColor={styles[type].underlayColor(selected) as any}>
      <>
        {data.image && <Image {...styles[type].imageStyle} source={data.image} />}
        {data.text && <Text {...styles[type].textStyle(selected)}>{data.text}</Text>}
      </>
    </Box>
  )
}

export default CarousalItem
